export const socialMediaLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=https://`,
    twitter: `https://x.com/intent/tweet?url=https://`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=https://`,
};
